/* jshint esnext: true */
/**
 * scroll top
 ***********************/
$(() => {
  $('.js-scrollTop').on('touchstart click', () => {
    $('html, body').animate({ scrollTop: 0 }, 500);

    return false;
  });
});

